import { gql } from 'react-apollo';

export const getSettings = gql`
  query getSettings {
    settings {
      passwordResetTokenLifetime: password_reset_token_lifetime
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/settings/queries/getSettings.js